import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { EyeIcon, EyeClosedIcon } from 'components';
import './inputPassword.scss';

export const PasswordSimpleField = (props) => {
  const [imageTypeState, setImageType] = useState(false);
  const toggleImage = () => setImageType(!imageTypeState);

  const Icon = imageTypeState ? EyeIcon : EyeClosedIcon;
  const type = imageTypeState ? 'text' : 'password';

  const { label, name } = props;

  return (
    <label className="password-component input-component">
      <span className="input-component__label">{label}</span>
      <input type={type} name={name} {...props} />
      <Icon onClick={toggleImage} style={{ minWidth: '10px' }} />
    </label>
  );
};

PasswordSimpleField.propTypes = {
  label: PropTypes.string,
};

PasswordSimpleField.defaultProps = {
  label: 'Password:',
};
